import { useEffect, useState } from 'react'
import Calendar from 'react-calendar'
import IntlPolyfill from 'intl'
import { formatDate, scrollTo } from '@utils/helpers'
import Spacer from '@components/Ui/Spacer'
import Icon from '@components/Ui/Icon'
import classNames from 'classnames'
import config from '@config'
import styles from './DateSelect.scss'
import 'intl/locale-data/jsonp/de.js'
import 'intl/locale-data/jsonp/en.js'
import 'intl/locale-data/jsonp/fr.js'
import 'intl/locale-data/jsonp/hr.js'
import 'intl/locale-data/jsonp/sr.js'
import 'intl/locale-data/jsonp/bs.js'
import 'intl/locale-data/jsonp/sl.js'

// eslint-disable-next-line no-undef
if (global.Intl) {
  Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat
} else {
  // eslint-disable-next-line no-undef
  global.Intl = IntlPolyfill
}

const DateSelect = ({ selected, slots, selectDay }) => {
  const [value, onChange] = useState(new Date())
  const slotKeys = Object.keys(slots || {})

  const onClickedDay = (day) => {
    console.log(day)

    selectDay(formatDate(day, 'yyyy-MM-dd'))
    onChange(day)

    scrollTo('time-slots')
  }

  useEffect(() => {
    if (selected) {
      return
    }
    const firstAvailableSlot = slotKeys[0]

    if (firstAvailableSlot) {
      selectDay(firstAvailableSlot)
      onChange(new Date(firstAvailableSlot))
    }
  }, [selected, slotKeys])

  let hasSaturdays = false

  Object.keys(slots).every((key) => {
    const date = new Date(key)
    if (date.getDay() === 6) {
      hasSaturdays = true
      return false
    }
    return true
  })

  const calendarLocale = config.get('local.locale')

  return (
    <div className={styles.base}>
      <Calendar
        className={classNames('ft-robo_md', hasSaturdays ? 'has-saturdays' : 'no-saturdays')}
        defaultView="month"
        view="month"
        maxDate={new Date(slotKeys[slotKeys.length - 1])}
        minDate={new Date()}
        maxDetail="month"
        minDetail="month"
        locale={calendarLocale}
        value={value}
        onClickDay={onClickedDay}
        nextLabel={<Icon type="arrow-right" size={12} />}
        next2Label={null}
        prevLabel={<Icon type="arrow-left" size={12} />}
        prev2Label={null}
        returnValue="start"
        showNeighboringMonth
        selectRange={false}
        showWeekNumbers={false}
        navigationLabel={({ date }) => (
          <span className="ft-robo_xlg_bold">{formatDate(date, 'MMMM yyyy')}</span>
        )}
        tileDisabled={({ date }) => {
          const dateFormatted = formatDate(date, 'yyyy-MM-dd')
          return !slots[dateFormatted]?.length
        }}
        tileClassName={({ date }) => {
          const dateFormatted = formatDate(date, 'yyyy-MM-dd')
          return 'ft-slab_sm_bold ' + (slots[dateFormatted]?.length ? 'has-slots' : '')
        }}
      />
      <Spacer vertical scale="0.5" />
    </div>
  )
}

DateSelect.defaultProps = {
  selected: null,
  slots: {},
  selectDay: () => {},
}
DateSelect.propTypes = {}

export default DateSelect
